/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IReinitOauthIntegrationAuthMutationVariables = Types.Exact<{
  integrationId: Types.Scalars['ID']['input'];
}>;

export type IReinitOauthIntegrationAuthMutation = {
  __typename?: 'Mutation';
  reinitOauthIntegrationAuth?: {
    __typename?: 'ReinitAuthPayload';
    success: boolean;
    errors?: Array<string> | null;
    integrationAuth?: { __typename?: 'IntegrationAuth'; url: string; stateToken: string } | null;
  } | null;
};

export const ReinitOauthIntegrationAuthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'reinitOauthIntegrationAuth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reinitOauthIntegrationAuth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'integrationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'integrationAuth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateToken' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IReinitOauthIntegrationAuthMutation, IReinitOauthIntegrationAuthMutationVariables>;
